import { FC, useState } from 'react';

import { RecordsBrowser } from '../components/records';
import FormSidebar from '../components/artifacts/FormSidebar';
import { CompositeFieldSidebar } from '../components/CompositeField';
import { SidebarControlProvider, SidebarView } from '../providers/SidebarControlProvider';

/**
 * Records page content: a list-detail browser (records left, record editor
 * right) wrapped in the sidebar providers the editor relies on. Entity, group,
 * status, and query selection is URL-driven inside RecordsBrowser.
 */
const EntitiesPageContent: FC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeView, setActiveView] = useState<SidebarView>('entity');

    return (
        <SidebarControlProvider
            setIsSidebarOpen={setIsSidebarOpen}
            setActiveView={setActiveView}
        >
            <RecordsBrowser />
            <FormSidebar
                isOpen={isSidebarOpen}
                onClose={() => setIsSidebarOpen(false)}
                activeView={activeView}
                setActiveView={setActiveView}
                availableViews={['entity']}
            />
            <CompositeFieldSidebar />
        </SidebarControlProvider>
    );
};

export default EntitiesPageContent;
